"use client";
import { Button } from "@/core/components/ui/button";
import { Download, Printer, X, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ReportViewerHeaderActionsProps } from "../types";

export function ReportViewerHeaderActions({
  isGeneratingPDF,
  onDownloadPDF,
  onClose,
}: ReportViewerHeaderActionsProps) {
  const [translate] = useTranslation(["insights"]);
  return (
    <div className="flex gap-2">
      <Button
        onClick={onDownloadPDF}
        className="gap-2"
        disabled={isGeneratingPDF}
      >
        {isGeneratingPDF ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Download className="h-4 w-4" />
        )}
        {isGeneratingPDF
          ? translate("report-viewer-header-actions-generating-pdf")
          : translate("report-viewer-header-actions-download-pdf")}
      </Button>
      <Button onClick={onClose} variant="ghost" size="icon">
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
